import axios from "axios";

// export const BASE_URL = "http://15.206.52.141:3209/api";
// export const BASE_URL = "https://api.tallyelearning.com/api";
// export const BASE_URL = "http://localhost:5023/api";
// export const BASE_URL = "http://localhost:8000/api";
// export const BASE_URL = "https://tally.wkbusiness.co.in/public/api";
// export const BASE_URL = "http://65.1.136.153/backend/public/api";
export const BASE_URL = "https://backend.tallyelearning.com/api";
const instance = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

export default instance;
